// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"TaskTemplateTagSearch__searchWrapper__2BKCo","searchbar":"TaskTemplateTagSearch__searchbar__1dn6N","icon":"TaskTemplateTagSearch__icon__3sqEj","input":"TaskTemplateTagSearch__input__2rGm_","chip":"TaskTemplateTagSearch__chip__3P94g","closeIcon":"TaskTemplateTagSearch__closeIcon__31JwQ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/TaskTemplateTagSelection/TaskTemplateTagSearch/TaskTemplateTagSearch.scss
// module id = 1741
// module chunks = 0